var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppliedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_clock-check-outline",
    "data-name": "MDI / clock-check-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 16.667,
    viewBox: "0 0 16.667 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.667,
    height: 16.667,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15.667,
    height: 15.667,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_clock-check-outline",
    "data-name": "Path / clock-check-outline",
    d: "M16.931,12.417l-3.472,3.472-2.431-2.431,1.042-1.042,1.389,1.389,2.431-2.431,1.042,1.042M9.708,14.431a2.849,2.849,0,0,1-.764.069A5.556,5.556,0,1,1,14.5,8.944a2.849,2.849,0,0,1-.069.764,4.189,4.189,0,0,1,1.319.417,6.842,6.842,0,0,0,.139-1.181,6.944,6.944,0,1,0-6.944,6.944,6.116,6.116,0,0,0,1.181-.139,3.686,3.686,0,0,1-.417-1.319M11.444,10.4,9.292,9.153V5.472H8.25V9.639L10.681,11.1A3.64,3.64,0,0,1,11.444,10.4Z",
    transform: "translate(-1.306 -0.786)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedIcon);
export default __webpack_public_path__ + "static/media/appliedIcon.2a826d5343bbdc642711b331742d9ec4.svg";
export { ForwardRef as ReactComponent };